__webpack_require__.p = "https://bundle.stayforlong.com/20251105.4/_next/";